import { type } from "./actionTypes"

const initialState = {
  dailyWorkReportSave: {},
}

const dailyWorkReport = (state = initialState, action) => {
  switch (action.type) {
    case type.SAVE_LOCAL_DAILY_WORK_REPORT:
      console.log("action.data", action.payload.value)
      let facId = action.payload.value.facId
      let date = action.payload.value.date

      return {
        ...state,
        dailyWorkReportSave: {
          ...state.dailyWorkReportSave,
          [facId]: {
            ...state.dailyWorkReportSave[facId],
            [date]: action.payload.value,
          },
        },
      }
    case type.REMOVE_SAVE_REPORT: {
      const { facId: rFacId, date: rDate } = action.payload.value
      const existing = state.dailyWorkReportSave[rFacId]
      if (!existing) return state
      // Immutable delete so components keyed on the nested object re-render.
      const { [rDate]: _removed, ...restForFac } = existing
      return {
        ...state,
        dailyWorkReportSave: {
          ...state.dailyWorkReportSave,
          [rFacId]: restForFac,
        },
      }
    }
    default:
      return state
  }
}

export default dailyWorkReport
